import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { GalleryPage } from "../features/design-gallery";

export const Route = createFileRoute("/design")({
  component: DesignRoute,
});

function DesignRoute(): JSX.Element {
  return <GalleryPage />;
}
